import { unitDecisions } from 'module/AfterCopyright/AfterCopyrightContentControl';

export const actionButtonsComiteeName = {
  supervisorControlDecision: 0,
  ownComiteeControlDecisions: 1,
  euAndPubControlDecisions: 2,
  euPubControlDecision: 3,
};

const actionBottonsArray = ({ encyclopediaUnit = false }) => {
  const actionButtons = {
    0: [
      {
        label: 'MADDEYİ YÜKLE',
        decicionPath: unitDecisions.accept,
        col: 24,
        routePath: 'madde-sorumlusu-karar',
      },
    ],
    1: [
      {
        label: 'KABUL',
        decicionPath: unitDecisions.accept,
        col: encyclopediaUnit ? 8 : 12,
        routePath: 'heyet-karar',
      },
      {
        label: 'MADDE SORUMLUSUNA GÖNDER',
        decicionPath: unitDecisions.sendToSupervisor,
        col: encyclopediaUnit ? 8 : 12,
        routePath: 'heyet-karar',
      },
    ],
    2: [
      {
        label: 'KABUL',
        decicionPath: unitDecisions.accept,
        col: encyclopediaUnit ? 8 : 12,
        routePath: 'heyet-karar',
      },
      ...(encyclopediaUnit
        ? [
            {
              label: 'İADE',
              decicionPath: unitDecisions.revert,
              col: 8,
              routePath: 'heyet-karar',
            },
          ]
        : []),
      {
        label: 'REDAKSİYON',
        decicionPath: unitDecisions.redaction,
        col: encyclopediaUnit ? 8 : 12,
        routePath: 'heyet-karar',
      },
    ],
    3: [
      {
        label: 'KABUL',
        decicionPath: unitDecisions.accept,
        col: 6,
        routePath: 'heyet-karar',
      },
      {
        label: 'İADE',
        decicionPath: unitDecisions.revert,
        col: 6,
        routePath: 'heyet-karar',
      },
      {
        label: 'İNCELE',
        decicionPath: unitDecisions.review,
        col: 6,
        routePath: 'heyet-karar',
      },
      {
        label: 'REDDET',
        decicionPath: unitDecisions.reject,
        col: 6,
        routePath: 'heyet-karar',
      },
    ],
  };
  return actionButtons;
};
export default actionBottonsArray;
